import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--down",
  "use": "icon-arrow--down-usage",
  "viewBox": "0 0 22 14",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 14\" id=\"icon-arrow--down\"><path d=\"m21.577 3.235-9.562 9.562a1.435 1.435 0 0 1-2.032 0L.42 3.235a1.437 1.437 0 1 1 2.032-2.032L11 9.751l8.547-8.549a1.437 1.437 0 0 1 2.032 2.032l-.002.001Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol